class MegaMenuHover extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimeout = null;

    this.setupEvents();
  }

  setupEvents() {
    // 鼠标悬停事件
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    // 保持原有的焦点和切换事件
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // 处理主链接点击事件
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', this.onSummaryClick.bind(this));
    }
  }

  onMouseEnter() {
    // 清除任何挂起的关闭操作
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }

    // 展开mega menu
    this.open();
  }

  onMouseLeave() {
    // 延迟关闭，给用户时间移动到子菜单
    this.hoverTimeout = setTimeout(() => {
      this.close();
    }, 150);
  }

  onSummaryClick(event) {
    const mainLink = event.currentTarget.querySelector('.mega-menu__main-link');
    if (mainLink && event.target.closest('.mega-menu__main-link')) {
      // 点击的是主链接，阻止details切换，允许导航
      event.preventDefault();
      window.location.href = mainLink.getAttribute('href');
    }
    // 点击其他区域，保持原有的切换行为
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());

      // 设置header底部位置
      if (this.header) {
        this.header.preventHide = true;
        if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
          document.documentElement.style.setProperty(
            '--header-bottom-position-desktop',
            `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
          );
        }
      }
    } else {
      this.animations.forEach((animation) => animation.cancel());

      if (this.header) {
        this.header.preventHide = false;
      }
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
  }
}

customElements.define('mega-menu-hover', MegaMenuHover);